<template>
  <div>
    <div class="title mt-5">
      <h3 class="d-flex justify-content-center header">
        {{$t('headers.hearing_test')}}
      </h3>
    </div>
    <div class="custom-container">

      <div class="form-wrapper">

        <!-- <div class="d-flex justify-content-center mt-3">
          <span class="header header-4">{{primaryResultText}}</span>
        </div>

        <div class="d-flex justify-content-center mt-2">
          <span class="header header-4">{{secondaryResultText}}</span>
        </div> -->

        <div class="form row mx-md-5 pb-5 px-3 px-md-5">

          <form class="col-12" novalidate>

            <div class="d-flex justify-content-center">
              <span class="header header-4">{{$t('headers.contact_info')}}</span>
            </div>

            <div class="form-row">
              <div class="col-12">
                <!-- <label class="custom-label" for="name">{{$t('form.name')}}</label> -->
                <input v-model="form.data.name"
                      id="name"
                      type="text"
                      :placeholder="$t('form.name')"
                      maxlength="255"
                      class="form-control"
                      :class="{'is-invalid': errors.has('name')}"
                      @focus="errors.clear('name')"
                  >
                <div class="invalid-feedback" v-show="errors.has('name')">
                  {{errors.get('name')}}
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-12">
                <!-- <label class="custom-label" for="phone">{{$t('form.phone')}}</label> -->
                <input v-model="form.data.phone"
                      id="phone"
                      type="text"
                      :placeholder="$t('form.placeholders.phone')"
                      maxlength="16"
                      class="form-control"
                      :class="{'is-invalid': errors.has('phone')}"
                      @focus="errors.clear('phone')"
                  >
                <div class="invalid-feedback" v-show="errors.has('phone')">
                  {{errors.get('phone')}}
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-12">
                <!-- <label class="custom-label" for="email">{{$t('form.email')}}</label> -->
                <input v-model="form.data.email"
                      id="email"
                      type="text"
                      :placeholder="$t('form.email')"
                      maxlength="255"
                      class="form-control"
                      :class="{'is-invalid': errors.has('email')}"
                      @focus="errors.clear('email')"
                  >
                <div class="invalid-feedback" v-show="errors.has('email')">
                  {{errors.get('email')}}
                </div>
              </div>
            </div>

            <div class="form-row" v-if="$i18n.locale !== 'pt' && !form.data.contact_request">
              <div class="col-12">
                <!-- <label class="custom-label" for="name">{{$t('form.city')}}</label> -->
                <input v-model="form.data.city"
                      id="city"
                      type="text"
                      :placeholder="$t('form.city')"
                      maxlength="255"
                      class="form-control"
                      :class="{'is-invalid': errors.has('city')}"
                      @focus="errors.clear('city')"
                  >
                <div class="invalid-feedback" v-show="errors.has('city')">
                  {{errors.get('city')}}
                </div>
              </div>
            </div>

            <div class="form-row" v-if="$i18n.locale === 'pt'">
              <div class="col-12 col-md-6">
                <select v-model="distrito"
                  @change="onChangeDistrito"
                  class="form-control"
                  :class="{'is-invalid': errors.has('distrito')}"
                  @focus="errors.clear('distrito')"
                  required>
                  <option :value="null" disabled selected>Distrito</option>
                  <option v-for="(item, index) in distritoOptions">{{ index }}</option>
                </select>
                <div class="invalid-feedback">
                  {{errors.get('distrito')}}
                </div>
              </div>
              <div class="col-12 col-md-6">
                <select v-model="concelho"
                  :disabled="distrito==null"
                  class="form-control"
                  :class="{'is-invalid': errors.has('concelho')}"
                  @focus="errors.clear('concelho')"
                  required>
                  <option :value="null" disabled selected>Concelho</option>
                  <option v-for="(item, index) in distritoOptions[distrito]">{{ item }}</option>
                  <!-- <option v-for="option in distritoOptions[distrito]" value="option.size">{{option.prize}}</option> -->
                </select>
                <div class="invalid-feedback">
                  {{errors.get('concelho')}}
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-12">
                <div class="checkbox__container">
                  <span v-if="form.data.contact_request" @click="form.data.contact_request = false" class="i-checkbox-selected"></span>
                  <span v-else @click="form.data.contact_request = true" class="i-checkbox"></span>
                  <label class="checkbox__label" for="checkbox-contact-request">{{$t('form.contact_request')}}</label>
                </div>
              </div>
            </div>

            <div class="form-row" v-if="form.data.contact_request">
              <div class="col-12">
                <input v-model="form.data.address_line_1"
                      id="address_line_1"
                      type="text"
                      :placeholder="$t('form.address')"
                      maxlength="255"
                      class="form-control"
                      :class="{'is-invalid': errors.has('address_line_1')}"
                      @focus="errors.clear('address_line_1')"
                  >
                <div class="invalid-feedback" v-show="errors.has('address_line_1')">
                  {{errors.get('address_line_1')}}
                </div>
              </div>
            </div>

            <div class="form-row mb-5" v-if="form.data.contact_request">
              <div class="col-12 col-md-6">
                <input v-model="form.data.address_postal_code"
                      id="address_postal_code"
                      type="text"
                      :placeholder="$t('form.postal_code')"
                      maxlength="255"
                      class="form-control"
                      :class="{'is-invalid': errors.has('address_postal_code')}"
                      @focus="errors.clear('address_postal_code')"
                  >
                <div class="invalid-feedback" v-show="errors.has('address_postal_code')">
                  {{errors.get('address_postal_code')}}
                </div>
              </div>
              <div class="col-12 col-md-6">
                <input v-model="form.data.address_city"
                      id="address_city"
                      type="text"
                      :placeholder="$t('form.city')"
                      maxlength="255"
                      class="form-control"
                      :class="{'is-invalid': errors.has('address_city')}"
                      @focus="errors.clear('address_city')"
                  >
                <div class="invalid-feedback" v-show="errors.has('address_city')">
                  {{errors.get('address_city')}}
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-12">
                <div class="checkbox__container">
                  <span v-if="userAgreesToPrivacyPolicy" @click="userAgreesToPrivacyPolicy = false" class="i-checkbox-selected"></span>
                  <span v-else @click="userAgreesToPrivacyPolicy = true" class="i-checkbox"></span>
                  <label class="checkbox__label" for="checkbox-privacy-policy">{{$t('results.accept_passing_data_to_partners')}}</label>
                </div>
              </div>
            </div>


            <div class="form-row">
              <div class="col-12">
                <div class="checkbox__container">
                  <span v-if="form.data.marketing" @click="form.data.marketing = false" class="i-checkbox-selected"></span>
                  <span v-else @click="form.data.marketing = true" class="i-checkbox"></span>
                  <label class="checkbox__label" for="checkbox-marketing">{{$t('results.accept_marketing_purposes')}}</label>
                </div>
              </div>
            </div>

            <div class="form-row">
              <div class="col-12">
                <span class="span-link" @click.prevent="showModal">{{$t('results.see_privacy_policy')}}</span>
              </div>
            </div>
          </form>
        </div>

        <modal
          name="dialog"
          :width="modalWidth"
          height="auto"
          :delay="50"
          scrollable
          adaptive
          transition="fade-in"
          class="modal__container">
          <div style="min-height: 50vh;">
            <iframe style="width: 100%; height: 100%; position: absolute;" :src="$i18n.locale === 'en' ? 'https://evollu.com/legal/hearing-test/en/privacy_notice.html' : 'https://evollu.com/legal/hearing-test/pt/privacy_notice.html'" frameborder="0"></iframe>
          </div>
        </modal>

        <div class="actions d-flex justify-content-center mb-3">
          <button type="button" :disabled="isSubmiting || !userAgreesToPrivacyPolicy" class="button primary" :class="{'disabled': isSubmiting || !userAgreesToPrivacyPolicy}" style="white-space: normal;" @click="submit">{{$t('actions.receive_result')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import Distritos from '../utils/Distritos'
import VModal from 'vue-js-modal'
Vue.use(VModal)
export default {
  props: {
    hasHearingLoss: {
      type: Boolean,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      required: true
    },
    isSubmiting: {
      type: Boolean,
      required: true
    }
  },
  mounted: function () {
    // this.$ga.event({
    //   eventCategory: 'questionnaire',
    //   eventAction: 'questionnaire-score',
    //   eventLabel: 'Valor do questionário',
    //   eventValue: this.questionnaireScore
    // })
    this.form.data = JSON.parse(JSON.stringify(this.user))
  },
  data: function () {
    return {
      form: {
        data: {
          name: null,
          city: null,
          address_line_1: null,
          address_postal_code: null,
          address_city: null,
          email: null,
          phone: null,
          birthdate: null,
          gender: null,
          contact_request: false,
          marketing: false
        }
      },
      userAgreesToPrivacyPolicy: false,
      distrito: null,
      concelho: null,
      distritoOptions: Distritos.distritos,
    }
  },
  methods: {
    showModal: function () {
      this.$modal.show('dialog')
    },
    onChangeDistrito: function (event) {
      this.concelho = null
    },
    submit: function () {
      this.validateForm()

      if (this.formIsValid) {
        this.$emit('continue')
      }
    },
    validateForm: function () {
      let errors = {}

      if (this.form.data.name === null) {
        errors['name'] = this.$t('form.errors.required_name')
      } else if (this.form.data.name.trim().length === 0) {
        errors['name'] = this.$t('form.errors.required_name')
      } else if (this.form.data.name.trim().length > 255) {
        errors['name'] = this.$t('form.errors.maxlength_name')
      }
      if(this.$i18n.locale !== 'pt'){
        if (this.form.data.city === null) {
          errors['city'] = this.$t('form.errors.required_city')
        } else if (this.form.data.city.trim().length === 0) {
          errors['city'] = this.$t('form.errors.required_city')
        } else if (this.form.data.city.trim().length > 255) {
          errors['city'] = this.$t('form.errors.maxlength_city')
        }
      }
      if (this.form.data.email === null) {
        errors['email'] = this.$t('form.errors.required_email')
      } else if (this.form.data.email.trim().length === 0) {
        errors['email'] = this.$t('form.errors.required_email')
      } else if (this.form.data.email.trim().length > 255) {
        errors['email'] = this.$t('form.errors.invalid_email')
      } else if (!this.form.data.email.match(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)) {
        errors['email'] = this.$t('form.errors.invalid_email')
      }

      if (this.form.data.phone === null) {
        errors['phone'] = this.$t('form.errors.required_phone')
      } else if (this.form.data.phone.trim().length === 0) {
        errors['phone'] = this.$t('form.errors.required_phone')
      } else {
        let locale = this.$i18n.locale == 'en' ? 'GB' : 'PT'
        const phoneNumber = parsePhoneNumberFromString(this.form.data.phone, locale)
        if (!(phoneNumber && phoneNumber.isValid())) {
          errors['phone'] = this.$t('form.errors.invalid_phone')
        }
      }

      if (this.$i18n.locale === 'pt') {
        if (this.concelho === null) {
          errors['concelho'] = this.$t('form.errors.required_concelho')
          if (this.distrito === null) errors['distrito'] = this.$t('form.errors.required_distrito')
        } else {
          this.form.data.city =  this.distrito + ', ' + this.concelho
        }
      }

      console.log(this.form.data.contact_request)
      if (this.form.data.contact_request) {
        if (this.form.data.address_line_1 === null) {
          errors['address_line_1'] = this.$t('form.errors.required_address')
        } else if (this.form.data.address_line_1.trim().length === 0) {
          errors['address_line_1'] = this.$t('form.errors.required_address')
        } else if (this.form.data.address_line_1.trim().length > 255) {
          errors['address_line_1'] = this.$t('form.errors.maxlength_address')
        }

        if (this.form.data.address_postal_code === null) {
          errors['address_postal_code'] = this.$t('form.errors.required_postal_code')
        } else if (this.form.data.address_postal_code.trim().length === 0) {
          errors['address_postal_code'] = this.$t('form.errors.required_postal_code')
        } else if (this.form.data.address_postal_code.trim().length > 255) {
          errors['address_postal_code'] = this.$t('form.errors.maxlength_postal_code')
        }

        if (this.form.data.address_city === null) {
          errors['address_city'] = this.$t('form.errors.required_city')
        } else if (this.form.data.address_city.trim().length === 0) {
          errors['address_city'] = this.$t('form.errors.required_city')
        } else if (this.form.data.address_city.trim().length > 255) {
          errors['address_city'] = this.$t('form.errors.maxlength_city')
        }
      }

      this.errors.record(errors)

    }
  },
  computed: {
    primaryResultText: function () {
      return this.hasHearingLoss ? this.$t('results_stage.hearing_loss.has_loss') : this.$t('results_stage.hearing_loss.ok')
    },
    secondaryResultText: function () {
      return this.hasHearingLoss ? this.$t('results_stage.recommendations.schedule') : this.$t('results_stage.recommendations.yearly_test')
    },
    formIsValid: function () {
      return !this.errors.any()
    },
    modalWidth: function () {
      return this.isMobileDevice ? '75%' : '65%'
    }
  },
  watch: {
    'form.data': function (value) {
      this.$emit('update:user', value)
    },
    'form.data.city' (value) {
      if (this.$i18n.locale !== 'pt') {
        this.form.data.address_city = value
      }
    },
    'form.data.address_city' (value) {
      if (this.$i18n.locale !== 'pt') {
        this.form.data.city = value
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.span-link {
  cursor: pointer;
  color: #29c4a9;;
  text-decoration: underline;
}

.i-checkbox {
  display: inline-block;
  width: 18px;
  min-width: 18px;
  height: 18px;
  background: url('../../../public/checkbox.svg') no-repeat center center;
  background-size: contain;
  cursor: pointer;
  margin-right: 5px;
}

.i-checkbox-selected {
  display: inline-block;
  width: 18px;
  min-width: 18px;
  height: 18px;
  background: url('../../../public/checkbox_selected.svg') no-repeat center center;
  background-size: contain;
  cursor: pointer;
  margin-right: 5px;
}

.checkbox__container {
  display: flex;
  justify-content: start;
  align-items: center;
  margin-left: 0;

  & .i-checkbox,.i-checkbox-selected {
    margin-right: 0.8rem;
  }

  & input {
    margin-right: 1rem;
    width: 15px;
    height: 15px;
    border-radius: 50%;
  }

  & .checkbox__label {
    color: #495057;;
    margin-bottom: 0;
  }
}

.hearing-loss-icon-box {
  padding: 0.75rem 2rem;
  color:#dc3545;
  border-right: solid 1px #d3d3d3;
}

.hearing-loss-icon-box i {
  font-size: 1.5rem;
}

.hearing-loss-message {
  padding: 0rem 2rem;
}

@media screen and  (max-width: 768px) {

  .hearing-loss-icon-box {
      border-right: none;
  }

  .hearing-loss-message {
    text-align: center;
  }
}

@media screen and  (min-width: 1196px) {

  .form-wrapper {
    margin: 2.5rem 22.5%;
  }

}

</style>